import { createContext, useContext } from 'react';

interface PermissionsContextValue {
    permissions: string[];
    hasPermission: (perm: string) => boolean;
    hasAnyPermission: (perms: string[]) => boolean;
}

const defaultValue: PermissionsContextValue = {
    permissions: [],
    hasPermission: () => false,
    hasAnyPermission: () => false,
};

export const PermissionsContext = createContext<PermissionsContextValue>(defaultValue);
export const usePermissions = () => useContext(PermissionsContext);
